/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 9/2/2023
 */
import {Type} from "@qwoach/class-transformer-wrapper";
import TagItem from "@shared/Tags/TagItem";
import BaseObject from "@shared/BaseObject";

export default class AutoTagsData extends BaseObject {

	isEnabled: boolean = false

	@Type(() => TagItem)
	tags: TagItem[] = []


	constructor(tags: TagItem[]) {
		super();
		this.tags = tags || [];
	}
}
